import { useState } from 'react'
import Link, { LinkProps } from '@mui/material/Link'

import { PAGE_NAMES } from '@/constants'

import NotificationsMenu from '@/Components/Layout/Nav/NotificationsMenu'
import UserMenu from '@/Components/Layout/Nav/UserMenu'
import { Row } from '@/Components/Layout/Row'
import { usePage } from '@/Components/Pages/PageProvider'

const Nav = () => {
  const { currentUser } = usePage()
  const {
    permissions: {
      certificationLetters: { view: canViewCertificationLetters = false }
    }
  } = currentUser || {}
  useState<null | HTMLElement>(null)
  const linkProps = (): LinkProps => {
    return {
      underline: 'none',
      sx: {
        color: 'primary.main',
        fontSize: 20,
        fontWeight: 600,
        minHeight: '48px',
        display: 'flex',
        alignItems: 'center',
        borderBottom: '2px solid transparent',
        '&:hover, &:focus': {
          borderColor: 'primary.main'
        },
        '&:active': {
          paddingBottom: 0.25
        }
      }
    }
  }

  return (
    <Row component="nav" alignItems="stretch" gap={4}>
      <Row
        sx={{
          borderRight: '1px solid',
          borderRightColor: 'primary.main',
          pr: 5
        }}
        alignItems="center"
        gap={4}
      >
        <Link component="a" href="/assessments" {...linkProps()}>
          {PAGE_NAMES.assessments.index}
        </Link>
        {canViewCertificationLetters && (
          <Link component="a" href="/certification_letters" {...linkProps()}>
            {PAGE_NAMES.certificationLetters.index}
          </Link>
        )}
      </Row>
      <NotificationsMenu />
      <UserMenu />
    </Row>
  )
}

export default Nav
